module.exports = __webpack_public_path__ + "static/img/xs1-2.3193f5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-2.png
// module id = 794
// module chunks = 0